import { render, staticRenderFns } from "./projectGeneration.vue.js?vue&type=template&id=480594f0&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./projectGeneration.vue?vue&type=template&id=480594f0&scoped=true"
import script from "./projectGeneration.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./projectGeneration.vue?vue&type=script&lang=js"
export * from "./projectGeneration.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./projectGeneration.vue?vue&type=script&lang=js"
import style0 from "./projectGeneration.vue.scss?vue&type=style&index=0&id=480594f0&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./projectGeneration.vue?vue&type=style&index=0&id=480594f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480594f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480594f0')) {
      api.createRecord('480594f0', component.options)
    } else {
      api.reload('480594f0', component.options)
    }
    module.hot.accept("./projectGeneration.vue.js?vue&type=template&id=480594f0&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./projectGeneration.vue?vue&type=template&id=480594f0&scoped=true", function () {
      api.rerender('480594f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/taskCenter/projectGeneration.vue"
export default component.exports